import { Card, CardContent, Grid } from '@material-ui/core';
import { Formik } from 'formik';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import FormBtns from '../../../../common/components/buttons/formBtns';
import CardContainer from '../../../../common/components/cards/cardContainer';
import {
  AppNotificationDto,
  appNotificationInit,
  notificationValidationSchema,
} from '../../notifications.dto';
import NotificationForm from '../form/notificationForm';
import ConfirmDialog from '../../../../common/components/dialog/confirmDialog';
import { createNotificationActions } from '../../notifications.actions';
import { getType } from 'typesafe-actions';

const NotificationCard = () => {
  const dispatch = useDispatch();

  const [dto, setDto] = useState<AppNotificationDto>(appNotificationInit);
  const [dialogValues, setDialogValues] =
    useState<AppNotificationDto>(appNotificationInit);
  const [open, setOpen] = useState(false);

  const openConfirmDialog = (values: AppNotificationDto) => {
    setDialogValues(values);
    setOpen(true);
  };

  const onDialogClose = () => {
    setOpen(false);
  };

  const onConfirm = (values: AppNotificationDto) => {
    onDialogClose();

    dispatch({
      type: getType(createNotificationActions.request),
      payload: { ...values },
    });
    setDto(appNotificationInit);
  };

  return (
    <>
      {open ? (
        <ConfirmDialog
          open={open}
          onClose={onDialogClose}
          confirmText='Send'
          value={dialogValues}
          onConfirm={onConfirm}
        />
      ) : null}
      <Formik
        initialValues={dto}
        validationSchema={notificationValidationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            setSubmitting(false);
          }, 700);

          openConfirmDialog(values);
        }}
        enableReinitialize={true}
      >
        {(props) => {
          const {
            values,
            errors,
            isSubmitting,
            touched,
            isValid,
            setFieldValue,
            handleBlur,
            handleChange,
            handleSubmit,
            resetForm,
          } = props;
          return (
            <form onSubmit={handleSubmit} noValidate>
              <CardContainer
                title='Notifications'
                cards={
                  <Grid container item spacing={2}>
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          <NotificationForm
                            values={values}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />

                          <Grid container justify='flex-end'>
                            <FormBtns
                              isSubmitting={isSubmitting}
                              onClose={resetForm}
                              saveText='Send'
                              cancelText='Reset'
                            />
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                }
              />
            </form>
          );
        }}
      </Formik>
    </>
  );
};

export default NotificationCard;
